// extracted by mini-css-extract-plugin
export default {"wrapper":"AssessmentWrapper_wrapper__i5-xO"};